import * as React from "react";
const SvgIconPlus = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "#4B009B", viewBox: "0 0 20 20", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M17.573 9.203h-6.704V2.5H9.203v6.703H2.5v1.667h6.703v6.703h1.666V10.87h6.703z" }));
export default SvgIconPlus;
